module.exports = __webpack_public_path__ + "img/login-barrionuevo.1e5f4b85.svg";